import React from "react";
import { Header } from ".";
import {ChatWidget} from "./ChatWidget";
export const Layout = ({ children }) => {
  return (
    <>
      <Header />
      {children}
       <ChatWidget />
      {/* <footer>
        <p style={{ textAlign: "center" }}> All rights reserved. @Asgar</p>
      </footer> */}
    </>
  );
};
